import React from 'react';
import './Cali.css'; 

const Armenia = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKAR.pdf" target="_blank" rel="noreferrer">Aeropuerto El Edén</a></h1>
    
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 02</th>                      
          </tr>  
          
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/AXM2H.pdf" target="_blank" rel="noreferrer">AXM2H</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/AXM2H.pdf" target="_blank" rel="noreferrer">PEI2E</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/AXM2H.pdf" target="_blank" rel="noreferrer">TORO2C</a></th>
          </tr>
                 
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/AXM3A.pdf" target="_blank" rel="noreferrer">AXM3A</a></th>
          </tr>          
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/AXM3A.pdf" target="_blank" rel="noreferrer">PEI3D</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/AXM3A.pdf" target="_blank" rel="noreferrer">TORO3B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/DOSG3A.pdf" target="_blank" rel="noreferrer">DOSG3A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/DOSG3C.pdf" target="_blank" rel="noreferrer">PEI4G</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/DOSG3C.pdf" target="_blank" rel="noreferrer">TOLI5A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/DOSG3C.pdf" target="_blank" rel="noreferrer">TORO3D</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKAR/DOSG3C.pdf" target="_blank" rel="noreferrer">DOSG3C</a></th>
          </tr>
          
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 02</th>                      
          </tr>
        
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ISNO2F.pdf" target="_blank" rel="noreferrer">ISNO2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/MATR5D.pdf" target="_blank" rel="noreferrer">MATR5D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/MATR5D.pdf" target="_blank" rel="noreferrer">PEI5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ISNO2J.pdf" target="_blank" rel="noreferrer">ISNO2J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ISNO2J.pdf" target="_blank" rel="noreferrer">MATR2H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ISNO2J.pdf" target="_blank" rel="noreferrer">UIB2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ISNO2J.pdf" target="_blank" rel="noreferrer">SIBO2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ISNO2J.pdf" target="_blank" rel="noreferrer">TORO2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ISNO2K.pdf" target="_blank" rel="noreferrer">ISNO2K</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 20</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ILSX20.pdf" target="_blank" rel="noreferrer">ILS X</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ILSY20.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/ILSZ20.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/LOC20.pdf" target="_blank" rel="noreferrer">LOC</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/RNP20.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/VORY20.pdf" target="_blank" rel="noreferrer">VOR Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKAR/VORZ20.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Armenia;